import * as React from 'react';
import { SVGProps } from 'react';

const IconFileAudioSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M9 8.78V18a3 3 0 0 1-3 3H5a2 2 0 1 1 0-4h2a1 1 0 0 0 1-1V7.562a2 2 0 0 1 1.515-1.94l9.242-2.311A1 1 0 0 1 20 4.28V15a3 3 0 0 1-3 3h-1a2 2 0 1 1 0-4h2a1 1 0 0 0 1-1V6.14a.5.5 0 0 0-.621-.485L9.757 7.811A1 1 0 0 0 9 8.78Z" />
  </svg>
);
export default IconFileAudioSizeM;
